import styled from "@emotion/styled";

export default function ModalViewAdminCharities({ onClose, charityData = {} }) {
  return (
    <RootWrapperModalAdminpayments>
      <Overlay>
        <Wrapper>
          <StatusUpdate>
            <Left>
              <Frame58>
                {/* Header */}
                <Frame1391>
                  <Frame1527>
                    <Frame1527_0001>
                      <AddPayment>Charity Detials</AddPayment>
                    </Frame1527_0001>
                  </Frame1527>
                </Frame1391>

                {/* Form */}
                <Frame1391>
                  <img src={charityData.logo} alt="Logo" />
                  <Frame1476>
                    <Title>Charity Title</Title>
                    <Description>{charityData.name} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Number </Title>
                    <Description>{charityData.number} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Short Description </Title>
                    <Description>{charityData.short_description} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Long Description </Title>
                    <Description>{charityData.long_description} </Description>
                  </Frame1476>

                  <ContactDetails>Contact Details</ContactDetails>

                  <Frame1476>
                    <Title>Contact Number </Title>
                    <Description>{charityData.contact_number} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Person to Contact </Title>
                    <Description>{charityData.contact_number} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Address </Title>
                    <Description>{charityData.address} </Description>
                  </Frame1476>
                  <Frame1476>
                    <Title>Postal Code </Title>
                    <Description>{charityData.postal_code} </Description>
                  </Frame1476>
                </Frame1391>
              </Frame58>
            </Left>
          </StatusUpdate>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminpayments>
  );
}

const RootWrapperModalAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const StatusUpdate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 610px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 610px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const Frame1476 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  gap: var(--Padding-Tiny, 4px);
  align-self: stretch;
  width: 100%;
`;
const Title = styled.div`
  color: var(--Color-Text-Gray, #64748b);

  /* P4 */
  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
  align-self: stretch;
  text-align: left;
`;
const Description = styled.div`
  color: var(--inputs-default-label-text, #000);

  /* P3 */
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 25.6px */
  letter-spacing: -0.16px;
  align-self: stretch;
  text-align: left;
`;

const Frame1527 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1527_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 610px;
  box-sizing: border-box;
`;

const AddPayment = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  width: 612px;
  flex: 1;
`;
const ContactDetails = styled.span`
  color: var(--Color-Text-Text, #212543);

  /* P1 */
  font-family: Montserrat;
  font-size: var(--Fonts-P1, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 32px */
  flex: 1 0 0;
`;
